import { render, staticRenderFns } from "./SingleChange.vue?vue&type=template&id=0aa71ec2&scoped=true&"
import script from "./SingleChange.vue?vue&type=script&lang=js&"
export * from "./SingleChange.vue?vue&type=script&lang=js&"
import style0 from "./SingleChange.vue?vue&type=style&index=0&id=0aa71ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa71ec2",
  null
  
)

export default component.exports